import { render, staticRenderFns } from "./PackagesList.vue?vue&type=template&id=3762941b&scoped=true&"
import script from "./PackagesList.vue?vue&type=script&lang=js&"
export * from "./PackagesList.vue?vue&type=script&lang=js&"
import style0 from "./PackagesList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PackagesList.vue?vue&type=style&index=1&id=3762941b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3762941b",
  null
  
)

export default component.exports